<div class="message-popup-wrapper">
  <div
    class="message-popup-header"
    *ngIf="
      isFrom !== 'air-waybill-commercial-invoice' &&
      isFrom !== 'air-waybill-gen-preview'
    ">
    <div class="ibc-body-text-large-bold">{{ messagePopupData.title }}</div>
    <div class="card-action-icons">
      <app-svg-icon
        [iconName]="'close'"
        class="cursor"
        [isStaticSvg]="true"
        [isFrom]="'Popup'"
        (staticIconClicked)="closePopup('close')"></app-svg-icon>
    </div>
  </div>

  <div class="message-popup-content">
    <div
      class="ibc-body-text-medium confirmation-message message-text"
      *ngIf="messagePopupData.code?.message || messagePopupData.message">
      {{ messagePopupData.code?.message || messagePopupData.message }}
    </div>

    <ul
      class="validation-section-list ibc-body-text-medium"
      *ngIf="messagePopupData.code?.validationSections?.length">
      <li *ngFor="let section of messagePopupData.code.validationSections">
        {{ section }}
      </li>
    </ul>

    <div
      class="ibc-body-text-medium confirmation-message message-text validation-section-footer"
      *ngIf="messagePopupData.code?.footerMessage">
      {{ messagePopupData.code.footerMessage }}
    </div>

    <ng-container *ngIf="messagePopupData.code?.renderTable">
      <div class="shipment-gateway-table">
        <app-summary-table
          [tableData]="shipmentTrackerTableData"
          [columnDefs]="shipmentGateTrackerGridColumns"
          [showActionButton]="true"
          [actionButtonLabel]="'Proceed'"
          (actionClicked)="proccedAndCloseShipmentSelection($event)">
        </app-summary-table>
      </div>

      <div *ngIf="!shipmentTrackerTableData?.length">
        <p>No data available</p>
      </div>
    </ng-container>

    <ng-container *ngIf="isFrom === 'terms-and-conditions'">
      <div class="injected-component-container">
        <ng-container *ngComponentOutlet="injectedComponent"></ng-container>
      </div>
    </ng-container>

    <app-commercial-invoice
      *ngIf="isFrom === 'air-waybill-commercial-invoice'"
      [airwayBillInvoiceData]="
        messagePopupData.code.data
      "></app-commercial-invoice>

    <app-air-waybill-generation-preview
      *ngIf="isFrom === 'air-waybill-gen-preview'"
      [airwayBillData]="
        messagePopupData.code.data
      "></app-air-waybill-generation-preview>
  </div>

  <div class="message-popup-footer" *ngIf="isFrom !== 'terms-and-conditions' || messagePopupData.code?.isFooterRequired || messagePopupData.isFooterRequired">
    @if (
      isFrom === 'air-waybill-gen-preview' &&
      !messagePopupData.code?.isFromHistory
    ) {
      <button
        mat-button
        class="mat-button-md ibc-primary-dark-button-md"
        [matMenuTriggerFor]="shareAirWaybill"
        [matMenuTriggerRestoreFocus]="false"
        #trigger="matMenuTrigger"
        (menuClosed)="reopenMenu(trigger)">
        Share Air Waybill via email
      </button>
      <mat-menu
        #shareAirWaybill="matMenu"
        yPosition="above"
        class="share-air-waybill"
        [hasBackdrop]="true"
        [overlapTrigger]="false">
        <div
          class="share-container"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()">
          <mat-form-field appearance="outline" class="mat-md">
            <mat-label>Email</mat-label>
            <input
              matInput
              placeholder="Enter email"
              [formControl]="email"
              (blur)="addEmailToList()"
              (focus)="$event.stopPropagation()" />
            <mat-error *ngIf="email?.invalid && email?.touched">
              {{ emailError }}
            </mat-error>
          </mat-form-field>
          <div class="recipients-container">
            <div class="header">
              <span class="ibc-customer-heading-regular-light"
                >Email Recipients</span
              >
            </div>
            <div class="content">
              <div class="entry" *ngFor="let email of emailList; let i = index">
                <span class="ibc-customer-heading-regular">
                  {{ email }}
                </span>
                <app-svg-icon
                  [iconName]="'close'"
                  class="cursor air-waybill"
                  [isStaticSvg]="true"
                  [isFrom]="'Popup'"
                  (click)="onRemoveIconClicked(i)"
                  (keydown)="$event.stopPropagation()"></app-svg-icon>
              </div>
            </div>
          </div>
          <div class="footer">
            <button
              mat-button
              class="ibc-secondary-dark-button"
              (click)="closeMenu()">
              Cancel
            </button>
            <button
              mat-button
              class="ibc-primary-dark-button-md"
              (click)="sendMail()">
              Send
            </button>
          </div>
        </div>
      </mat-menu>
    }
    <div *ngIf="popupButtons && popupButtons.length > 0">
      @for (button of popupButtons; track button.id) {
        <button
          mat-button
          class="{{ button.class }}"
          (click)="onPopupButtonClick(button.id)">
          {{ button.label }}
        </button>
      }
    </div>
  </div>
</div>
